export default "__VITE_ASSET__D4wmcd5I__"